import React, { useEffect, useRef } from 'react'
import { useStateValue } from '../../../StateProvider';
import { MdOutlinePreview } from 'react-icons/md';
import { getClassNamesOfNotificationStatus } from '../../../utils/colorCode';
import { extractDateTime } from '../../../utils/FormateDate';
import { isAdmin } from '../../../utils/adminAccess';
import { IoMdSearch } from 'react-icons/io';
import { convertToUserOptions, customStyles } from '../../../utils/ConvertToOptions';
import Select from 'react-select'

export default function NotificationList({ buttonRef,
    isStaffNotification,
    isFilterOpen,
    setIsFilterOpend,
    funHandler,
    handleConfirmationClose,
    confirmationShow,
    ConfirmationModal,
    currentPage,
    handlePageChange,
    removeSelection,
    totalPages,
    filteredData,
    viewTask,
    notificationId,
    currentItems,
    isLoading,
    handleIsStatusChange,
    isStatusFilter,
    userList,
    handleUserChange,
    userFilter,
    handleSearch,
    searchInput,
    addNewNotification,
    searchInputWeb,
    searchInputMobile,
    setTab,
    searchQuery

}) {
    const [{ sysConfig, userInfo }, dispatch] = useStateValue();

    // ****************************************** accordion start *********************************************
    const statusTitle = (status, projectType) => {
        if (projectType === "over_due") {
            return "List of Over due Project";
        } else if (status === "1" || projectType === "up_coming") {
            return "List of Up Coming Project";
        } else if (status === "2" || projectType === "on_going") {
            return "List of On Going Project";
        } else if (status === "3" || projectType === "under_review") {
            return "List of Under Review Project";
        } else if (status === "4") {
            return "List of Completed Project";
        } else if (status === "5") {
            return "List of Cancelled Project";
        } else {
            return "List of Project";
        }
    };
    //   const [isFilterOpen, setIsFilterOpend] = useState(true)
    const collapseRef = useRef(null);


    useEffect(() => {
        // Ensure the ref points to the correct element
        const collapseElement = collapseRef.current;

        // Event listener for when the accordion is opened
        const handleShown = () => {
            console.log('Accordion is opened');
            setIsFilterOpend(true)
        };

        // Event listener for when the accordion is closed
        const handleHidden = () => {
            setIsFilterOpend(false)

            console.log('Accordion is closed');
        };

        // Attach event listeners for Bootstrap collapse events
        collapseElement.addEventListener('shown.bs.collapse', handleShown);
        collapseElement.addEventListener('hidden.bs.collapse', handleHidden);

        // Cleanup listeners when component unmounts
        return () => {
            collapseElement.removeEventListener('shown.bs.collapse', handleShown);
            collapseElement.removeEventListener('hidden.bs.collapse', handleHidden);
        };
    }, []);


    // ****************************************** accordion end *********************************************
    // ****************************************** accordion close when click outside start *********************************************
    const handleClickOutside = (event) => {
        if (collapseRef.current && !collapseRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) {
            if (window.bootstrap) {

                const collapseInstance = new window.bootstrap.Collapse(collapseRef.current, {
                    toggle: false
                });
                collapseInstance.hide();
            }
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // ****************************************** accordion close when click outside end *********************************************
    useEffect(() => {
        setIsFilterOpend(true)
    }, [])
    return (
        <div id={`${isStaffNotification ? "app-content" : ""}`}>
            {/* Container fluid */}
            <div className={`${isStaffNotification ? "app-content-area" : ""}`}>
                <div className="container-fluid">
                    <div className="row web-view">
                        <div className={`${isStaffNotification ? "col-lg-12 col-md-12 col-12" : "d-none"}`}>
                            {/* Page header */}
                            <div className="mb-5">
                                <h3 className="mb-0 ">
                                    {isStaffNotification && "Staff Notifiction"}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div>
                        {/* row */}
                        <div className="row">
                            <div className="col-12">
                                {/* card */}
                                <div className="card mb-4">
                                    <div className="accordion position-absolute w-100 z-3 mobile-view" id="accordionExample">
                                        <div className="accordion-item">
                                            <h2 className="accordion-header bg-white" id="headingOne">
                                                <button className="accordion-button" type="button" data-bs-toggle="collapse" ref={buttonRef}
                                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    <strong>
                                                        {isStaffNotification ? "Staff Notifiction" : `Notifiction`}
                                                    </strong>
                                                </button>
                                            </h2>
                                            <div id="collapseOne" className="accordion-collapse collapse show" ref={collapseRef}
                                                aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                <div className="card-header">
                                                    <div className=" ">
                                                        <div className="row  justify-content-end">
                                                            <div className="ps-2 pe-2 col-lg-2 col-md-4  mt-md-3">
                                                                <div
                                                                    className="btn btn-primary w-100 "
                                                                    onClick={() => addNewNotification()}
                                                                >
                                                                    + Add Notification
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <>
                                                        <div className="row justify-content-between">
                                                            <div className=" col-lg-4 col-md-6 mt-3 mt-md-3 d-flex">
                                                                <input
                                                                    ref={searchInputMobile}
                                                                    type="search"
                                                                    className="form-control "
                                                                    defaultValue={searchQuery}
                                                                    onChange={(e) => {
                                                                        if (e.target.value === "") {
                                                                            handleSearch();
                                                                        }
                                                                    }}
                                                                    placeholder="Search for Name & Description."
                                                                />
                                                                <div
                                                                    className="btn btn-primary ms-3"
                                                                    onClick={() => handleSearch()}
                                                                >
                                                                    <IoMdSearch size={25} />
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-2 col-md-4  mt-3 mt-md-3">
                                                                {isAdmin(userInfo) && (
                                                                    // <select
                                                                    //     className="form-select"
                                                                    //     aria-label="Default select example"
                                                                    //     value={userFilter}
                                                                    //     onChange={handleUserChange}
                                                                    // >
                                                                    //     <option disabled>Select User</option>
                                                                    //     <option selected="" value={""}>
                                                                    //         All
                                                                    //     </option>

                                                                    //     {userList.map((item) => (
                                                                    //         <option value={item}>{item}</option>
                                                                    //     ))}
                                                                    // </select>
                                                                    <Select
                                                                        // className="form-select"
                                                                        styles={customStyles}
                                                                        // value={userFilter ? { label: userFilter, value: userFilter } : ""}
                                                                        value={userFilter ? { label: userFilter, value: userFilter } : { label: "All", value: "" }}


                                                                        placeholder="Select user."
                                                                        onChange={handleUserChange}

                                                                        options={[{ label: "Select a user", value: "Select a user", isDisabled: true }, { label: "All", value: "" }, ...convertToUserOptions(userList)]}
                                                                    />
                                                                )}
                                                            </div>
                                                            <div className="col-lg-2 col-md-4  mt-3 mt-md-3">
                                                                <select
                                                                    className="form-select"
                                                                    aria-label="Default select example"
                                                                    value={isStatusFilter}
                                                                    onChange={handleIsStatusChange}
                                                                >
                                                                    <option disabled>Select Status</option>
                                                                    <option selected="" value={""}>
                                                                        All
                                                                    </option>
                                                                    <option value={1}>Pending</option>
                                                                    <option value={2}>Read</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-header web-view">
                                        <div className=" ">
                                            <div className="row  justify-content-end">
                                                <div className="ps-2 pe-2 col-lg-2 col-md-4 mt-3 mt-md-3">
                                                    <div
                                                        className="btn btn-primary w-100 "
                                                        onClick={() => addNewNotification()}
                                                    >
                                                        + Add Notification
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <>
                                            <div className="row justify-content-between">
                                                <div className=" col-lg-4 col-md-6 mt-3 mt-md-3 d-flex">
                                                    <input
                                                        ref={searchInputWeb}
                                                        type="search"
                                                        className="form-control "
                                                        defaultValue={searchQuery}
                                                        onChange={(e) => {
                                                            if (e.target.value === "") {
                                                                handleSearch();
                                                            }
                                                        }}
                                                        placeholder="Search for Name & Description."
                                                    />
                                                    <div
                                                        className="btn btn-primary ms-3"
                                                        onClick={() => handleSearch()}
                                                    >
                                                        <IoMdSearch size={25} />
                                                    </div>
                                                </div>

                                                <div className="col-lg-2 col-md-4  mt-3 mt-md-3">
                                                    {isAdmin(userInfo) && (
                                                        // <select
                                                        //     className="form-select"
                                                        //     aria-label="Default select example"
                                                        //     value={userFilter}
                                                        //     onChange={handleUserChange}
                                                        // >
                                                        //     <option disabled>Select User</option>
                                                        //     <option selected="" value={""}>
                                                        //         All
                                                        //     </option>

                                                        //     {userList.map((item) => (
                                                        //         <option value={item}>{item}</option>
                                                        //     ))}
                                                        // </select>
                                                        <Select
                                                            // className="form-select"
                                                            styles={customStyles}
                                                            value={userFilter ? { label: userFilter, value: userFilter } : { label: "All", value: "" }}

                                                            placeholder="Select user."
                                                            onChange={handleUserChange}

                                                            options={[{ label: "Select a user", value: "", isDisabled: true }, { label: "All", value: "" }, ...convertToUserOptions(userList)]}
                                                        />
                                                    )}
                                                </div>
                                                <div className="col-lg-2 col-md-4  mt-3 mt-md-3">
                                                    <select
                                                        className="form-select"
                                                        aria-label="Default select example"
                                                        value={isStatusFilter}
                                                        onChange={handleIsStatusChange}
                                                    >
                                                        <option disabled>Select Status</option>
                                                        <option selected="" value={""}>
                                                            All
                                                        </option>
                                                        <option value={1}>Pending</option>
                                                        <option value={2}>Read</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </>
                                    </div>
                                    {!isLoading ? (
                                        <>
                                            <div className="card-body">
                                                <div className="table-responsive table-card">
                                                    {currentItems.length > 0 ? (
                                                        <table className="table text-nowrap mb-0 responsive-table sub-table main-table table-centered table-hover">
                                                            <thead className="table-light">
                                                                <tr>
                                                                    <th className=" pe-0  ">
                                                                        Date <br />
                                                                        Time
                                                                    </th>
                                                                    <th className="">Notification</th>

                                                                    <th>
                                                                        Sent By <br />
                                                                        Sent To
                                                                    </th>
                                                                    <th>Status</th>
                                                                    <th style={{ width: "100px" }}>Action</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {currentItems.map((notification, index) => (
                                                                    <tr
                                                                        id={`user-${index}`}
                                                                        className={`${parseInt(notificationId) ===
                                                                            notification?.ID
                                                                            ? "table-primary"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        <td
                                                                            data-label1="Date"
                                                                            data-label2="Time"
                                                                            style={{
                                                                                width: "135px",
                                                                                textWrap: "wrap",
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className="d-flex flex-column gap-1"

                                                                            >
                                                                                <div className="div">

                                                                                    {extractDateTime(notification.DtTime).date}
                                                                                </div>
                                                                                <div>

                                                                                    {extractDateTime(notification.DtTime).time}
                                                                                </div>
                                                                                {/* <br /> */}
                                                                            </div>

                                                                        </td>
                                                                        <td
                                                                            className="name"

                                                                        >
                                                                            <div className="d-flex flex-column">

                                                                                <strong
                                                                                    className="cursor-pointer truncate"
                                                                                    onClick={() =>
                                                                                        viewTask(notification)
                                                                                    }
                                                                                >
                                                                                    {notification?.Subject}
                                                                                </strong>

                                                                                <div className="truncate">
                                                                                    <small>
                                                                                        {notification?.Description}
                                                                                    </small>
                                                                                </div>
                                                                            </div>
                                                                        </td>

                                                                        <td
                                                                            data-label1="Sent By"
                                                                            data-label2="Sent To"

                                                                            style={{
                                                                                width: "120px",
                                                                                textWrap: "wrap",
                                                                            }}
                                                                        >
                                                                            <div className="d-flex flex-column">

                                                                                <strong className=" truncate-1  mb-1">

                                                                                    {notification.SentBy}
                                                                                </strong>
                                                                                <div className="truncate-1 ">

                                                                                    {notification.SentTo}
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td
                                                                            data-label1="Status"

                                                                            style={{
                                                                                width: "120px",
                                                                                textWrap: "wrap",
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className={getClassNamesOfNotificationStatus(
                                                                                    notification.Status.text
                                                                                )}
                                                                            >
                                                                                {notification?.Status?.text}
                                                                            </div>
                                                                        </td>

                                                                        <td data-label1="Action"
                                                                            style={{
                                                                                width: "120px",
                                                                                textWrap: "wrap",
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className="btn btn-ghost btn-icon btn-sm rounded-circle texttooltip"
                                                                                data-template="editOne"
                                                                                onClick={() =>
                                                                                    viewTask(notification)
                                                                                }
                                                                            >
                                                                                <MdOutlinePreview
                                                                                    size={20}
                                                                                    style={{ fill: "#624bff" }}
                                                                                />
                                                                                <div
                                                                                    id="editOne"
                                                                                    className="d-none"
                                                                                >
                                                                                    <span>View</span>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    ) : (
                                                        <div className={` fs-3 ${isFilterOpen ? "show-margin" : "hidden-margin"}`}>
                                                            <strong>No records found.!</strong>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            {filteredData.length > 0 && (
                                                <div className="card-footer d-md-flex justify-content-between align-items-center">
                                                    <span>
                                                        Showing{" "}
                                                        {currentPage *
                                                            Number(sysConfig["Rows in MultiLine List"]) -
                                                            Number(sysConfig["Rows in MultiLine List"]) +
                                                            1}{" "}
                                                        to{" "}
                                                        {currentPage *
                                                            Number(sysConfig["Rows in MultiLine List"]) >=
                                                            filteredData.length
                                                            ? filteredData.length
                                                            : currentPage *
                                                            Number(
                                                                sysConfig["Rows in MultiLine List"]
                                                            )}{" "}
                                                        of {filteredData.length} entries
                                                    </span>
                                                    <nav className="mt-2 mt-md-0">
                                                        <ul className="pagination mb-0 ">
                                                            <li
                                                                className="page-item "
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => {
                                                                    if (currentPage > 1) {
                                                                        handlePageChange(currentPage - 1);
                                                                        removeSelection();
                                                                    }
                                                                }}
                                                            >
                                                                <div
                                                                    className={`page-link ${totalPages === currentPage
                                                                        ? "disabled"
                                                                        : ""
                                                                        } `}
                                                                >
                                                                    Previous
                                                                </div>
                                                            </li>
                                                            {Array(totalPages ? totalPages : 0)
                                                                .fill()
                                                                .map((item, index) => (
                                                                    <li
                                                                        style={{ cursor: "pointer" }}
                                                                        className={`${currentPage === index + 1
                                                                            ? "page-item active"
                                                                            : "page-item"
                                                                            } ${currentPage + 2 >= index + 1 &&
                                                                                index + 1 > currentPage - 2
                                                                                ? // currentPage - 2 < index + 1
                                                                                "d-block"
                                                                                : "d-none"
                                                                            }`}
                                                                        onClick={() => {
                                                                            handlePageChange(index + 1);
                                                                            removeSelection();
                                                                        }}
                                                                    >
                                                                        <div className="page-link">
                                                                            {index + 1}
                                                                        </div>
                                                                    </li>
                                                                ))}

                                                            <li className="page-item">
                                                                <div
                                                                    style={{ cursor: "pointer" }}
                                                                    className={`page-link ${totalPages === currentPage
                                                                        ? "disabled"
                                                                        : ""
                                                                        } `}
                                                                    onClick={() => {
                                                                        if (totalPages > currentPage) {
                                                                            removeSelection();
                                                                            handlePageChange(currentPage + 1);
                                                                        }
                                                                    }}
                                                                >
                                                                    Next
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </nav>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <div className="m-5 fs-3">
                                            <strong>Fetching records..</strong>
                                        </div>
                                    )}
                                    {!isStaffNotification &&
                                    <div className="row p-4 pt-0">
                                        <div className=" d-flex flex-wrap gap-3 align-items-center justify-content-end  ">
                                            <div
                                                className="btn btn-outline-danger  col-md-2 col-12 "
                                                style={{ height: "fit-content" }}
                                                onClick={() => {
                                                    setTab("information")
                                                }}
                                            >
                                                Back
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmationModal
                show={confirmationShow}
                onHide={handleConfirmationClose}
                funHandler={funHandler}
            />
        </div>
    )
}
